/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecReviewSREntityResultDataResponseStatus
 */
export interface SecReviewSREntityResultDataResponseStatus {
    /**
     * 
     * @type {number}
     * @memberof SecReviewSREntityResultDataResponseStatus
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof SecReviewSREntityResultDataResponseStatus
     */
    message?: string;
}

/**
 * Check if a given object implements the SecReviewSREntityResultDataResponseStatus interface.
 */
export function instanceOfSecReviewSREntityResultDataResponseStatus(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SecReviewSREntityResultDataResponseStatusFromJSON(json: any): SecReviewSREntityResultDataResponseStatus {
    return SecReviewSREntityResultDataResponseStatusFromJSONTyped(json, false);
}

export function SecReviewSREntityResultDataResponseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecReviewSREntityResultDataResponseStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function SecReviewSREntityResultDataResponseStatusToJSON(value?: SecReviewSREntityResultDataResponseStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'message': value.message,
    };
}

